/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FormAction {
    SAVE_DRAFT = 'SAVE_DRAFT',
    SUBMIT = 'SUBMIT',
}
